module.exports = __webpack_public_path__ + "static/preset-header-1-99762f1a171362f8ab013639556a1531.png";